import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import LatestUpdates from '@/pages/home/components/LatestUpdates';
import HotRecommend from '@/pages/home/components/HotRecommend';
import SiteIntro from '@/pages/home/components/SiteIntro';

export default function Home() {
  return (
    <div className="animate-fade-in">
      <HeroCarousel />
      <CategoryGrid />
      <LatestUpdates />
      <HotRecommend />
      <SiteIntro />
    </div>
  );
}